import styled from "styled-components";

export const GoodInput = styled.input`
  height: 30px;
  border-radius: 10px;
  margin: 10px 0px;
`;
